import React from 'react'
import './index.scss'
import { Link } from 'react-router'
import Navigation from '@App/navigation'
import Button from '@Components/Buttons/Button'
import { setCookie } from '@App/helpers/cookies'
import { PUBLIC_SEARCH_COOKIE } from '@Const/cookies'

interface PublicSearchPopupProps {
    closePopup: () => void
}

const PublicSearchPopup = (props: PublicSearchPopupProps) => {
    const setCookieAndClosePopup = () => {
        setCookie(PUBLIC_SEARCH_COOKIE, 'Y')
        props.closePopup()
    }

    return (
        <div className="public-search-modal-container">
            <h3>Welcome to The MLC&apos;s Public Work Search</h3>
            <p>The Public Work Search allows anyone to search The MLC’s song ownership database free of charge.</p>
            <p>The accuracy and completeness of The MLC’s data is determined solely by our Members.</p>
            <hr />
            <p>
                <strong>SONGWRITERS, COMPOSERS & LYRICISTS:</strong> If you are signed to a music publisher or
                administrator, please notify them directly if you find any data errors or missing registrations for any
                of your songs. The MLC is working on additional ways to help you flag and report data errors to your
                publisher or administrator. We hope to launch those later this year.
            </p>
            <p>
                <em>
                    The MLC’s database does <strong>not yet</strong> contain any data about unmatched royalties. We will
                    begin making unmatched royalty data available later this year.
                </em>
            </p>
            <div className="links-block">
                <p>
                    Please review the{' '}
                    <a href="https://www.themlc.com/musicalworksdatabasetermsuse">
                        Musical Works Database Terms of Use
                    </a>
                </p>
                <p>
                    If you have any questions, please <Link to={Navigation.contactUs.root()}>contact us</Link>.
                </p>
                <a href="https://themlc.com/newsletter-sign-up" target="_blank" rel="noreferrer">
                    Subscribe to our monthly newsletter!
                </a>
            </div>
            <div className="search-confirm-popup-content">
                <div className="buttons-block">
                    <p className="reappearance-notification">This message will reappear one week after it is closed.</p>
                    <Button mainColor type="primary" onClick={setCookieAndClosePopup}>
                        Continue
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default PublicSearchPopup
